import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DevicesService } from '../../../core/routing/services/devices/devices.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Device } from '../interface/devices-interface.i';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DevicesConstants, Enumvalues } from '../../../core/routing/services/devices/constants/devices.constants';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { throwError } from 'rxjs';
import { CommonService } from '../../../common/services/common.service';
import { WebsocketService } from '../../../core/routing/services/websocket/websocket.service';
import { DeviceStoreService } from '../store/device.store';
import { StoresConstant } from '../../../core/routing/services/stores_api/constants/stores.constant';
import { ActiveUserConstants } from '../../../core/routing/services/activeusers_api/constatnts/activeusers.constant';
import { RetailStoreCommonConstants } from '../../../common/constants/retailer-store.constant';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import * as processorNames from './../../../../assets/config/processor-names.json';
import { Processor } from '../interface/processor-names.i';
import { AppGlobal } from '../../../../app/core/state/app-global';
import { User } from '../../account/login/_models/user.model';
import moment from 'moment';
import { Router } from '@angular/router';
import { distinctUntilChanged } from 'rxjs/operators';
import { Utils } from '../../../common/utils/utils';

@Component({
  selector: 'iposcen-device-dashboard',
  templateUrl: './device-dashboard.component.html',
  styleUrls: ['./device-dashboard.component.scss']
})

export class DeviceDashboardComponent implements OnInit, OnDestroy {
  @ViewChild('searchValue') animateThis: ElementRef;
  @ViewChild('pushUpdateModal') updatePopup: ElementRef;
  @Input() pkgdata: any;
  isLoading = false;
  globConst = GlobalConstants;
  sendSelectedItem;
  allDevicesData = [];
  displayDevices = [];
  allUserscsvData = [];
  allSelectedDeviceInfo = [];
  pushUpdateConfirm: boolean;
  page: number;
  tableSize: number;
  showFrom: number;
  showTo: number;
  maxSize = 5;
  loadFlag: string;
  searchData: string;
  openModal = false;
  importdata: any = {};
  downloadFile = new Date().toLocaleDateString() + '_' + GlobalConstants.DEVICE_CSV_FILENAME_TEMPLATE + '.csv';
  finalName: string;
  fileName: string;
  document: any = {};
  successPopup = false;
  showcsvError = false;
  incorrectError = false;
  errorMessage: string;
  csvStore = [];
  file: any = {};
  valueForSearchInDevice: string;
  searchTag: string;
  searchClose: boolean;
  isDisabled = true;
  isAscendingSort = false;
  isUpdatesPushed: boolean;
  sideNav: string;
  updateDeviceInfo: Device;
  connectivityStatusHoverText = DevicesConstants.CONNECTIVITY_STATUS_HOVER;
  updateIconHoverText = DevicesConstants.UPDATE_ICON_HOVER;
  removeIconHoverText = DevicesConstants.REMOVE_ICON_HOVER;
  updateViaCsvHoverText = DevicesConstants.UPDATE_VIA_CSV_HOVER;
  updateViaCsv = DevicesConstants.UPDATE_VIA_CSV;
  updateStoreID = DevicesConstants.STORE_ID;
  updateDeviceID = DevicesConstants.DEVICE_UUID;
  updateDeviceIfo = GlobalConstants.DEVICE_INFO;
  updatePromoContent = GlobalConstants.PROMOTIONAL_CONTENT;
  updateMainTileAsset = GlobalConstants.MAIN_TILE_ASSET;
  updateSegment = GlobalConstants.SEGMENT_TEXT;
  updateBannerCarousel = GlobalConstants.BANNER_CAROUSEL_TEXT;
  updatePriceContent = GlobalConstants.PRICE_CONTENT_TEXT;
  updateIdleExperience = GlobalConstants.IDLE_EXPERIENCE;
  updateAutoshutdown = GlobalConstants.AUTO_SHUTDOWN_TXT;
  updateFactTags = GlobalConstants.FACT_TAGS;
  updatePushUpdates = GlobalConstants.PUSH_UPDATES;
  updateLastUpdate = DevicesConstants.LAST_UPDATE;
  noRecord = GlobalConstants.NO_RECORDS_FOUND;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  retailerID = sessionStorage.getItem(GlobalConstants.RETAILERID);
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  intelAdmin = GlobalConstants.INTEL_ADMIN;
  retailHqUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHqUser = GlobalConstants.REGIONALHQ;
  storeUser = GlobalConstants.STORE_USER;
  isMasterSel: boolean;
  selectedDeviceList = [];
  selectedDeviceNameList: string;
  closeFilter: boolean;
  allConnectivityStatusData = [];
  allSegmentData = [];
  allContentTypeData = [];
  allSkuData = [];
  allBrandData = [];
  allDeviceTypeData = [];
  allProcessorsData = [];
  allOperatingSystemData = [];
  allGamingNonGamingdeviceData = [];
  allPushStatusData = [];
  allVersionNumbersData = [];
  connectivityStatusDropdownSelectedValue: string;
  connectivityStatusFilterName = DevicesConstants.CONNECTIVITY_STATUS_VALUE_FILTER;
  gamingNonGamingDeviceDropdownSelectedValue: string;
  gamingNonGamingDeviceFilterName = DevicesConstants.GAMING_NONGAMING_DEVICE_VALUE_FILTER;
  segmentDropdownSelectedValue: string;
  segmentFilterName = DevicesConstants.SEGMENT_VALUE_FILTER;
  contentTypeDropdownSelectedValue: string;
  skuIdDropdownSelectedvalue: string;
  contentTypeFilterName = DevicesConstants.CONTENT_TYPE_VALUE_FILTER;
  SkuIdFilterName = DevicesConstants.SKU_ID_TYPE_FILTER;
  brandDropdownSelectedValue: string;
  brandFilterName = DevicesConstants.BRAND_VALUE_FILTER;
  deviceTypeDropdownSelectedValue: string;
  deviceTypeFilterName = DevicesConstants.DEVICE_TYPE_VALUE_FILTER;
  processorsDropdownSelectedValue: string;
  processorsFilterName = DevicesConstants.PROCESSORS_VALUE_FILTER;
  operatingSystemDropdownSelectedValue: string;
  operatingSystemFilterName = DevicesConstants.OPERATING_SYSTEM_VALUE_FILTER;
  pushStatusFilterName = DevicesConstants.PUSH_STATUS_VALUE_FILTER;
  versionNumberFilterName = DevicesConstants.VERSION_NUMBER_VALUE_FILTER;
  deviceEvoFilterName = DevicesConstants.IS_DEVICE_EVO_VALUE_FILTER;
  filterString: string;
  pushStatusDropdownSelectedValue: string;
  versionNumberDropdownSelectedValue: string;
  deviceEvoDropdownSelectedValue: string;
  selectFilterQueue = {};
  searchQueue = {};
  sortQueue = {};
  // devicesData: Device[] = [];
  showHideFilters = true;
  devicesText: string;
  openDeleteModalPopup: boolean;
  isremoved: boolean;
  removeMessage: string;
  deviceName: string;
  isSingleDeviceSelected: boolean;
  singleDelete: string;
  cancelButton = GlobalConstants.CANCEL;
  segmentSuccess: boolean;
  infoSuccess = false;
  infoBannerSuccess: boolean;
  infoPriceSuccess: boolean;
  infoAutoshutdownSuccess: boolean;
  idleExperienceSuccess: boolean;
  promoSuccess = false;
  factTagSuccess = false;
  customMainSuccess = false;
  lastUpdate;
  direction: string;
  isGreek = localStorage.getItem('preferredLanguage') === 'el';
  isHungarian = localStorage.getItem('preferredLanguage') === 'hu';
  isPolish = localStorage.getItem('preferredLanguage') === 'pl';
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  searchLabel = DevicesConstants.SEARCH_TEXT;
  brandsLabel = DevicesConstants.BRANDS;
  deviceTypesLabel = DevicesConstants.DEVICE_TYPES;
  processorsLabel = DevicesConstants.PROCESSORES;
  operatingSystemsLabel = DevicesConstants.OPERATING_SYSTEMS;
  pushStatusLabel = DevicesConstants.PUSH_STATUS;
  versionNumberLabel = DevicesConstants.VERSION_NUMBER;
  hideFiltersLabel = DevicesConstants.HIDE_FILTERS;
  skuID = DevicesConstants.SKUID_SORT;
  deviceID = DevicesConstants.DEVICE_UUID_SORT;
  deviceNameSort = DevicesConstants.DEVICE_NAME_SORT;
  retailerNameSort = DevicesConstants.RETAILER_NAME_SORT;
  connectivityStatus = DevicesConstants.CONNECTIVITY_STATUS_SORT;
  storeName = DevicesConstants.STORE_NAME_SORT;
  storeNumber = DevicesConstants.STORE_NUMBER_SORT;
  brand = DevicesConstants.BRAND_SORT;
  segmentHeadline = DevicesConstants.SEGMENT_SORT;
  deviceUpdatedTime = DevicesConstants.LAST_UPDATE_SORT;
  lastConnectedTime = DevicesConstants.LAST_CONNECTED_SORT;
  deviceType = DevicesConstants.DEVICE_TYPE_SORT;
  profilePushStatus = DevicesConstants.PROFILE_PUSH_SORT;
  profileUpgradeDateTime = DevicesConstants.UPGRADE_TIME_SORT;
  profilePreviousPushTime = DevicesConstants.PREVIOUS_PUSH_TIME_SORT;
  iposLegalVersion = DevicesConstants.LEGAL_VERSION_SORT;
  paginationCount: number;
  totalPages: number;
  isAlldevicesSelected: boolean;
  globalSortValue: string;
  globalSortBy: string;
  isEnglish = localStorage.getItem('preferredLanguage') === 'en-US';
  isJapaneese = localStorage.getItem('preferredLanguage') === 'ja';
  isAllSelectedData = new Map();
  deviceNameVal = DevicesConstants.DEVICENAME;
  skuIdVal = DevicesConstants.SKUID;
  storeNameVal = DevicesConstants.STORENAME;
  storeNumberVal = DevicesConstants.STORENUMBER;
  deviceTypeVal = DevicesConstants.DEVICETYPE;
  segmentVal = DevicesConstants.SEGMENT;
  uuIdVal = DevicesConstants.UUID;
  processorModelVal = DevicesConstants.PROCESSOR_MODEL;
  uploadCSVNote = GlobalConstants.UPLOAD_CSV_NOTE;
  uploadedCSVError = GlobalConstants.GENERIC_ERROR_MSG_UPLOAD_CSV;
  deviceConst = DevicesConstants;
  private ngUnsubscribe = new Subject();
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  isOperatingChorm: boolean;
  isDeviceDataEmpty: boolean = false;
  pushEmptySkuId = false;
  showRetailGif = false;
  checkStatus: boolean;
  isSelectAllClicked = false;
  isGamingDevice = false;
  newProcessorData = [];
  newDeviceTypesData = [];
  processorNames: Processor = (processorNames as any).default; //UAT-592
  blockCall = false;
  retailerInfo: any;
  isAutoShutdown: boolean;
  customSrtEnabled: boolean;
  isDashboardPriceSupress = false;
  priceMetaData: any = {};
  isCollapsed = [];
  OsText = GlobalConstants.OS;
  processorText = GlobalConstants.PROCESSOR;
  batteryText = GlobalConstants.BATTERY_LIFE;
  devicePriceText = GlobalConstants.DEVICE_PRICE;
  primaryPriceText = GlobalConstants.PRIMARY_PRICE;
  secondaryPriceText = GlobalConstants.SECONDARY_PRICE;
  autoShutDownText = GlobalConstants.AUTOSHUTDOWN;
  devicInfoText = GlobalConstants.DEVICE_INFO_TEXT;
  enabledText = GlobalConstants.ENABLED;
  disabledText = GlobalConstants.DISABLED;
  isDevieExecutive: boolean = false;
  timePopup: boolean = false;
  deviceExecutive = GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE;
  editPublishDateInfo: string;
  isCustomPublishDateCorrect: boolean;
  customPublishDateResult: string;
  tempFullData: any;
  isCustomPublishTimeZoneSelected = false;
  showLicensePopUp = false;
  bandwidthPopup = false;
  //<!-- License -->
  page_subtitle = GlobalConstants.tr_license_agreement_subtitle;
  text1 = GlobalConstants.tr_license_agreement_text1;
  text2 = GlobalConstants.tr_license_agreement_text2;
  text3 = GlobalConstants.tr_license_agreement_text3;
  text4 = GlobalConstants.tr_license_agreement_text4;
  text5 = GlobalConstants.tr_license_agreement_text5;
  text6 = GlobalConstants.tr_license_agreement_text6;
  text7 = GlobalConstants.tr_license_agreement_text7;
  text8 = GlobalConstants.tr_license_agreement_text8;
  text9 = GlobalConstants.tr_license_agreement_text9;
  text10 = GlobalConstants.tr_license_agreement_text10;
  text11 = GlobalConstants.tr_license_agreement_text11;
  text12 = GlobalConstants.tr_license_agreement_text12;
  text13 = GlobalConstants.tr_license_agreement_text13;
  text14 = GlobalConstants.tr_license_agreement_text14;
  text15 = GlobalConstants.tr_license_agreement_text15;
  text16 = GlobalConstants.tr_license_agreement_text16;
  text17 = GlobalConstants.tr_license_agreement_text17;
  text18 = GlobalConstants.tr_license_agreement_text18;
  text19 = GlobalConstants.tr_license_agreement_text19;
  text20 = GlobalConstants.tr_license_agreement_text20;
  text21 = GlobalConstants.tr_license_agreement_text21;
  text22 = GlobalConstants.tr_license_agreement_text22;
  text23 = GlobalConstants.tr_license_agreement_text23;
  text24 = GlobalConstants.tr_license_agreement_text24;
  agree = GlobalConstants.tr_license_agreement_btn2_text;
  updatesPushed: boolean = false;
  isRequiredUserRolePresent: boolean = false;
  isProfilePage = false;
  blockoutExpanded: boolean = false;
  convertText;
  hourVal: string;
  minuteVal: string;
  dateObj = {} as any;
  datetimePickerFrm: FormGroup;
  compareVersion: any = '23CY3.0.0';
  compareLiteVersion: any = '24CY1.0.0';
  checkDisabled = false;
  pfID: string;
  ishideSelectAll: boolean = true;
  connectedStatusHoverText = DevicesConstants.CONNECTED_STATUS_HOVER_TEXT;
  disconnectedStatusHoverText = DevicesConstants.DISCONNECTED_STATUS_HOVER_TEXT;
  twoPlusweeksDisconnectedStatusHoverText = DevicesConstants.TWO_WEEKS_DISCONNECTED_HOVER_TEXT;
  statusHoverText: string;
  deviceUUIDText = GlobalConstants.DEVICE_UUID;
  retailerNameText = GlobalConstants.RETAILER_NAME_SEARCH;
  vaIncludedText = GlobalConstants.VA_INCLUDED;
  installationDatetimeText = GlobalConstants.INSTALLATION_DATETIME;
  isIposChinaEnabled: boolean = false;
  timeZoneCST: boolean = false;

  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    private devicesService: DevicesService,
    private modalService: NgbModal,
    private deviceStore: DeviceStoreService,
    private cmnService: CommonService,
    private websocketService: WebsocketService,
    private appGlobal: AppGlobal,
    private router: Router, private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.convertText = this.cmnService;
    this.page = 1;
    this.isOperatingChorm = false;
    this.isMasterSel = false;
    this.devicesText = $localize`:@@devices.update-popup.devices:Devices`;
    this.tableSize = 10;
    this.searchClose = false;
    this.pushUpdateConfirm = true;
    this.file = {};
    this.document = document;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.sideNav = (this.selectedDeviceList.length > 1) ? 'promo' : 'deviceInfo';
    this.valueForSearchInDevice = DevicesConstants.DEVICENAME;
    this.loadFlag = DevicesConstants.LOAD_FLAG;
    this.closeFilter = false;
    this.openDeleteModalPopup = false;
    this.isremoved = true;
    this.singleDelete = '';
    this.direction = this.cmnService.direction;
    this.isUpdatesPushed = false;
    this.editPublishDateInfo = GlobalConstants.NOW;
    this.dateObj = {
      hour: '00',
      min: '00'
    };
    //for IIT3-1135 Bug
    //this.globalSortBy = DevicesConstants.LAST_UPDATE_SORT;
    this.globalSortBy = DevicesConstants.CONNECTIVITY_STATUS_SORT;
    this.globalSortValue = DevicesConstants.DESCENDING_ORDER;
    if (this.router.url.includes(GlobalConstants.PROFILE_IPOS)) {
      this.isProfilePage = true;
    }
    this.pfID = this.isProfilePage ? this.pkgdata?.standardType ? encodeURIComponent(this.pkgdata.profileId) : this.pkgdata.profileId : '';
    if (this.isProfilePage) {
      this.retailerID = this.pkgdata.retailerID;
      this.globalSortValue = RetailStoreCommonConstants.DESCENDING_ORDER;
      this.globalSortBy = 'lastConnectedTime';
      this.getFilterSearchData();
      this.isDisabled = true;
      this.createDateTimePickerFrm();
    }
    if (this.userRole !== GlobalConstants.SRT_ADMIN) {
      this.getFilterSearchData();
    }
    this.cmnService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          this.showRetailGif = true;
        }
      });
    // To get Retailer Account details.
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        this.userRole = userAccount?.role;
        this.isDevieExecutive = this.userRole === this.deviceExecutive;
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ || this.userRole === this.deviceExecutive) {
          this.retailerInfo = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.cmnService.getRetailerConfig(this.userId, this.retailerID);
          this.isAutoShutdown = this.retailerInfo?.isAutoShutdown ? this.retailerInfo?.isAutoShutdown : false;
          this.customSrtEnabled = this.retailerInfo?.customSrtEnabled ? this.retailerInfo?.customSrtEnabled : false;
          this.isDashboardPriceSupress = this.retailerInfo?.isPriceSupress ? this.retailerInfo?.isPriceSupress : false;
          this.priceMetaData.enablePriceMultiDevices = this.retailerInfo?.enablePriceMultiDevices ? this.retailerInfo?.enablePriceMultiDevices : false;
          this.isIposChinaEnabled = this.retailerInfo?.isIposChinaEnabled ? this.retailerInfo?.isIposChinaEnabled : false;
        }
      });
    this.isRequiredUserRolePresent = [this.retailHqUser, this.regionalHqUser, this.deviceExecutive].indexOf(this.userRole) > -1;
  }

  getAllDevicesByUserId(filterString?: string) {
    // Websocket implementation for Retail/Regional users.
    if (this.userRole === this.retailHqUser || this.userRole === this.regionalHqUser || this.userRole === this.deviceExecutive) {
      this.checkStatus = true;
      this.websocketService.deviceDashboardWebSocketURL
        .subscribe(getAllDevicesResponse => {
          if (this.checkStatus && getAllDevicesResponse) {
            this.getAllDevicesDataForRetailer(filterString);
            this.checkStatus = false;
          }
          if (getAllDevicesResponse['device']) {
            if (!this.isSelectAllClicked && getAllDevicesResponse['device']['paginationContext'] !== undefined)
              this.mapResponseData(getAllDevicesResponse)
            /* else {
               getAllDevicesResponse['device']['device'].forEach(value => {
                 this.isAllSelectedData.set(value.deviceID, value);
               });
               this.getSelectedDevicesList();
             }*/
          }
        },
          error => {
            this.isDeviceDataEmpty = true;
            this.handleError(error, this.constructor.name);
          });
      this.websocketService.deviceDashboardWebSocketURL.next({
        "userID": this.userId
      });
    } else {
      this.getAllDevicesData(filterString);
    }
  }

  getAllDevicesDataForRetailer(filterString?: string) {
    if (this.isProfilePage) {
      filterString = filterString ? (filterString + `&package=${this.pfID}`) : `&package=${this.pfID}`
    }
    this.devicesService.getAllDevicesByUserID(this.globalSortBy, this.globalSortValue, this.page, filterString, this.retailerID)
      .subscribe(resp => {
      },
        error => {
          this.isDeviceDataEmpty = true;
          this.handleError(error, this.constructor.name);
        });
  }

  getAllDevicesData(filterString?: string) {
    if (this.isProfilePage) {
      filterString = filterString ? (filterString + `&package=${this.pfID}`) : `&package=${this.pfID}`
    }
    this.devicesService.getAllDevicesByUserID(this.globalSortBy, this.globalSortValue, this.page, filterString, this.retailerID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllDevicesResponse => {
        this.mapResponseData(getAllDevicesResponse);
      },
        error => {
          this.isDeviceDataEmpty = true;
          this.handleError(error, this.constructor.name);
        });
  }

  mapResponseData(response: any) {
    this.allDevicesData = this.isRequiredUserRolePresent ? response['device']['device'] as Device[] : response.device as Device[];
    this.paginationCount = this.isRequiredUserRolePresent ? response['device']['paginationContext'].totalItems : (response.paginationContext.totalItems);
    if (this.paginationCount == 1 && this.pkgdata?.allowNonIntel === false) {
      this.ishideSelectAll = false;
    } else {
      this.ishideSelectAll = true;
    }
    this.totalPages = this.isRequiredUserRolePresent ? response['device']['paginationContext'].totalPages : (response.paginationContext.totalPages);
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
    this.displayDevices = [];
    let deviceTypeList = []; // IIT2-5312
    this.isDeviceDataEmpty = (this.allDevicesData.length === 0) || false;
    this.allDevicesData.forEach(ele => {
      ele.isSelected = this.isMasterSel;
      this.displayDevices.push(ele);      
    });

    if (this.displayDevices.length === 0) {
      this.showFrom = 0;
      this.showTo = 0;
    } else {
      this.displayDevices = [];
      this.allDevicesData.forEach(ele => {
        ele.isSelected = this.isMasterSel;
        this.displayDevices.push(ele);
        this.isCollapsed.push(false);
        deviceTypeList.push(ele.deviceType); // IIT2-5312
      });
      //IIAT-1096
      this.allConnectivityStatusData = this.isRequiredUserRolePresent ? this.statusList().sort() : response.connectivityStatusList.sort();
      this.allSegmentData = this.isRequiredUserRolePresent ? response['device']['segmentList'].sort() : response.segmentList.sort();
      this.allContentTypeData = this.isRequiredUserRolePresent ? response['device']['contentTypeList'].sort() : response.contentTypeList.sort();
      // For IIT3-313
      this.allSkuData = this.isRequiredUserRolePresent ? response['device']['skuList'].filter(element => element !== '') : response.skuList.filter(element => element !== '');
      this.allSkuData.sort((a, b) => a.localeCompare(b));
      let blankSKUData = this.isRequiredUserRolePresent ? response['device']['device'].filter(ele => (ele.skuID == undefined || ele.skuID === '')) : response['device'].filter(ele => (ele.skuID == undefined || ele.skuID === '')); //IIT2-10874
      if (blankSKUData.length > 0) this.pushEmptySkuId = true;
      if (this.pushEmptySkuId && !this.allSkuData.includes(this.deviceConst.NO_SKU_ID)) {
        this.allSkuData.push(this.deviceConst.NO_SKU_ID);
        this.allSkuData.sort((a, b) => a.localeCompare(b));
      }
      this.allBrandData = this.isRequiredUserRolePresent ? response['device']['brandList'].sort() : response.brandList.sort();
      this.allDeviceTypeData = this.isRequiredUserRolePresent ? response['device']['deviceTypeList'].sort() : response.deviceTypeList.sort();
      this.allProcessorsData = this.isRequiredUserRolePresent ? response['device']['processorList'].sort() : response.processorList.sort();
      this.allOperatingSystemData = this.isRequiredUserRolePresent ? response['device']['operatingSystemList'].sort() : response.operatingSystemList.sort();
      //IGC-133 Enhancement in filtering gaming and non-gaming devices
      this.isGamingDevice = (this.userRole === this.retailHqUser || this.userRole === this.regionalHqUser || this.userRole === this.storeUser) ? response['device']['isGamingBattle']?.includes('yes') : false;
      //IIAT-1096 end
      if (this.isProfilePage) {
        this.allPushStatusData = this.isRequiredUserRolePresent ? (response.device?.pushProfileStatusList ? response['device']['pushProfileStatusList'].sort() : []) : response.pushProfileStatusList.sort();

        this.allVersionNumbersData = this.isRequiredUserRolePresent ? response['device']['iposLegalVersionList'].sort() : response.iposLegalVersionList.sort();
      }


      // Replacing Processor Values as per TradeMarks
      this.allDevicesData.forEach(ele => {
        if (ele.deviceConfigurations) {
          let displayValue = JSON.parse(ele.deviceConfigurations)?.cpu?.display?.en_US;
          if (displayValue.includes('-')) {
            displayValue = displayValue?.split('-')[0];
          } else {
            displayValue = displayValue.substring(0, displayValue.lastIndexOf(' '));
          }
          this.newProcessorData.push(displayValue);
        }
      });
      this.newProcessorData = [...new Set(this.newProcessorData)].sort();

      // Checking if VA is enable for each device
      this.displayDevices.forEach(ele => {
        if (ele.deviceConfigurations) {
          let vaEnable = JSON.parse(ele.deviceConfigurations)?.enableVA;
          ele.enableVA = vaEnable;
        }
      })

      //For replacing Device Types as per the Trademarks start
      this.newDeviceTypesData = this.allDeviceTypeData;
      this.newDeviceTypesData.forEach(ele => {
        if (ele === GlobalConstants.DEVICE_2_IN_1_OTHERS && this.newDeviceTypesData.indexOf(ele) !== -1) {
          this.newDeviceTypesData[this.newDeviceTypesData.indexOf(ele)] = GlobalConstants.DEVICE_2_IN_1_OTHERS_NEW;
        } else if (ele === GlobalConstants.DEVICE_2_IN_1_DETACHABLE && this.newDeviceTypesData.indexOf(ele) !== -1) {
          this.newDeviceTypesData[this.newDeviceTypesData.indexOf(ele)] = GlobalConstants.DEVICE_2_IN_1_DETACHABLE_NEW;
        } else if (ele === GlobalConstants.DEVICE_2_IN_1_CONVERTIBLE && this.newDeviceTypesData.indexOf(ele) !== -1) {
          this.newDeviceTypesData[this.newDeviceTypesData.indexOf(ele)] = GlobalConstants.DEVICE_2_IN_1_CONVERTIBLE_NEW;
        }
      });
      //For replacing Device Types as per the Trademarks start

      // To replace Device Type Values from Table start
      this.displayDevices.forEach(ele => {
        if (ele.deviceType === GlobalConstants.DEVICE_2_IN_1_OTHERS && this.displayDevices.indexOf(ele) !== -1) {
          this.displayDevices[this.displayDevices.indexOf(ele)].deviceType = GlobalConstants.DEVICE_2_IN_1_OTHERS_NEW;
        } else if (ele.deviceType === GlobalConstants.DEVICE_2_IN_1_DETACHABLE && this.displayDevices.indexOf(ele) !== -1) {
          this.displayDevices[this.displayDevices.indexOf(ele)].deviceType = GlobalConstants.DEVICE_2_IN_1_DETACHABLE_NEW;
        } else if (ele.deviceType === GlobalConstants.DEVICE_2_IN_1_CONVERTIBLE && this.displayDevices.indexOf(ele) !== -1) {
          this.displayDevices[this.displayDevices.indexOf(ele)].deviceType = GlobalConstants.DEVICE_2_IN_1_CONVERTIBLE_NEW;
        }
      });
      // To replace Device Type Values from Table end
    }
    this.cmnService.setRetailGifValue(false);
  }

  onTableDataChange(event) {
    this.isSelectAllClicked = false;
    this.page = event;
    if (this.isRequiredUserRolePresent) this.getAllDevicesDataForRetailer(this.filterString);
    else this.getAllDevicesByUserId(this.filterString);
  }

  sort(sortKey: string) {
    // this.isAllSelectedData.clear();
    this.isSelectAllClicked = false;
    this.isMasterSel = false;
    this.isDisabled = true;
    //UAT-597 Unselecting all if all 'select all' clicked before the sort. Similarly to filter and search
    if (sortKey) {
      this.sortingTableWithAscandDesc(sortKey);
    }
  }
  //IIAT-1159

  sortingTableWithAscandDesc(tempval: string) {
    this.globalSortValue = this.globalSortValue !== ActiveUserConstants.ASCENDING_ORDER ? ActiveUserConstants.ASCENDING_ORDER :
      RetailStoreCommonConstants.DESCENDING_ORDER;
    this.globalSortBy = tempval;
    this.getFilterSearchData();
  }
  //IIAT-1159 end 
  sortingTheUsersTable(tempval, temporder) {
    this.devicesService.sort(tempval, temporder)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(devicesResponse => {
        this.displayDevices = devicesResponse.device as Device[];
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
      });
  }
  onSelectChange(value) {
    this.blockCall = false;
    if (value === Enumvalues.VALUE_1) {
      this.searchTag = DevicesConstants.DEVICE_NAME_SEARCH;
      this.valueForSearchInDevice = DevicesConstants.DEVICENAME;
    } else if (value === Enumvalues.VALUE_2) {
      this.searchTag = DevicesConstants.SKUID_SEARCH;
      this.valueForSearchInDevice = DevicesConstants.SKUID;
    } else if (value === Enumvalues.VALUE_3) {
      this.searchTag = DevicesConstants.STORE_NAME_SEARCH;
      this.valueForSearchInDevice = DevicesConstants.STORENAME;
    } else if (value === Enumvalues.VALUE_4) {
      this.searchTag = DevicesConstants.STORE_NUMBER_SEARCH;
      this.valueForSearchInDevice = DevicesConstants.STORENUMBER;
    } else if (value === Enumvalues.VALUE_5) {
      this.searchTag = DevicesConstants.DEVICE_TYPE_SEARCH;
      this.valueForSearchInDevice = DevicesConstants.DEVICETYPE;
    } else if (value === Enumvalues.VALUE_6) {
      this.searchTag = DevicesConstants.SEGMENT_SEARCH;
      this.valueForSearchInDevice = DevicesConstants.SEGMENT;
    } else if (value === Enumvalues.VALUE_7) {
      this.searchTag = DevicesConstants.UUID_SEARCH;
      this.valueForSearchInDevice = DevicesConstants.UUID;
    } else if (value === Enumvalues.VALUE_8) {
      this.searchTag = DevicesConstants.PROCESSOR_MODEL_SEARCH;
      this.valueForSearchInDevice = DevicesConstants.PROCESSOR_MODEL;
    }
  }

  transformPushStatusText(status) {
    if (status) {
      if (status.toLowerCase() === DevicesConstants.PUSHED_TEXT.toLowerCase()) {
        return GlobalConstants.OTA_PACK_PUSHED_TEST;
      } else if (status.toLowerCase() === DevicesConstants.DWNLD_INPRG.toLowerCase()) {
        return GlobalConstants.OTA_PACK_DWNLD_STARTED;
      } else if (status.toLowerCase() === DevicesConstants.DWNLD_CMPTD.toLowerCase()) {
        return GlobalConstants.OTA_PACK_DWNLD_CMPLTD;
      } else if (status.toLowerCase() === DevicesConstants.INSTALL_START.toLowerCase()) {
        return GlobalConstants.OTA_PACK_INSTALL_STARTED;
      } else if (status.toLowerCase() === DevicesConstants.SYNCHED_TEXT.toLowerCase()) {
        return GlobalConstants.OTA_PACK_INSTALL_CMPLTD;
      } else if (status.toLowerCase() === DevicesConstants.INSTALL_FAILED.toLowerCase()) {
        return GlobalConstants.OTA_PACK_INSTALL_FAILED;
      } else if (status.toLowerCase() === DevicesConstants.DWNLD_FAILED.toLowerCase()) {
        return GlobalConstants.OTA_PACK_DOWNLOAD_FAILED;
      } else return status;
    }
  }

  searchtheDevicesonEnter(searchData) {
    this.searchClose = true;
    this.isMasterSel = false;
    this.isDisabled = true;
    this.animateThis.nativeElement.blur();
    if (!searchData) {
      this.searchClose = false;
    }
    if (this.loadFlag === DevicesConstants.LOAD_FLAG && !this.searchTag) {
      this.searchTag = DevicesConstants.DEVICE_NAME_SEARCH;
      this.loadFlag = DevicesConstants.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      this.devicesService.getUsersbySearch(this.searchTag, searchData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(getAllStoresResponse => {
          this.displayDevices = getAllStoresResponse.device as Device[];
          this.showFrom = ((this.page - 1) * this.tableSize) + 1;
          this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
          if (this.displayDevices.length === 0) {
            this.showFrom = this.paginationCount;
            this.showTo = this.paginationCount;
          }
        });
    } else {
      if (this.isRequiredUserRolePresent)
        this.getAllDevicesDataForRetailer();
      else this.getAllDevicesByUserId();
      this.page = 1;
    }
  }

  clearSearch(val: string) {
    if (val?.length === 0 && this.searchClose) {
      this.searchClose = false;
      this.animateThis.nativeElement.value = '';
      this.searchQueue = {};
      this.getFilterSearchData();
      this.searchData = DevicesConstants.EMPTY_VALUE;
      this.showFrom = this.page = 1;
      this.showTo = 10;
      this.isDisabled = true;
      this.isMasterSel = false;
      this.isAllSelectedData.clear();
    }
  }

  isAllSelected(data) {
    this.isSelectAllClicked = false;
    if (this.isAllSelectedData.has(data.deviceID)) {
      this.isAllSelectedData.delete(data.deviceID);
    } else {
      this.isAllSelectedData.set(data.deviceID, data);
    }
    this.allSelectedDeviceInfo = [];
    this.displayDevices.forEach(ele => {
      ele.isSelected = this.isAllSelectedData.has(ele?.deviceID);
    });
    const isAllChecked = this.displayDevices.every(item => {
      if (this.isAllSelectedData.size === this.paginationCount) {
        return true;
      } else {
        if (this.pkgdata?.allowNonIntel === false) {
          return (JSON.parse(item.deviceConfigurations)?.cpu.manufacturer !== GlobalConstants.INTEL || (JSON.parse(item.deviceConfigurations)?.cpu.confidence === 0));
        }
        else {
          if (item?.isIposLite && !this.isProfilePage) {
            return true;
          }
          return false;
        }
      }
    });

    this.isMasterSel = isAllChecked ? true : false;
    this.getSelectedDevicesList();
  }

  checkUncheckAll(event) {
    if (this.filterString) {
      this.isAllSelectedData.clear();
      if (event) {
        this.isSelectAllClicked = true;
        this.isMasterSel = this.isSelectAllClicked;
        if (this.isProfilePage && !this.filterString.includes(`&package=${this.pfID}`)) {
          this.filterString = this.filterString ? (this.filterString + `&package=${this.pfID}`) : `&package=${this.pfID}`
        }
        this.devicesService.selectAllDevices(this.filterString)
          .subscribe(res => {
            // Commenting below So that APP consumes API response(When select all clicked).
            //if (!(this.userRole === this.retailHqUser || this.userRole === this.regionalHqUser))
            {
              res.device.forEach(value => {
                if (this.isProfilePage || value.isIposLite) { // if non-intel devices included shouldn't be included when user click select all
                  if (!this.checkDisable(value)) {
                    this.isAllSelectedData.set(value.deviceID, value);
                  }
                } else {
                  this.isAllSelectedData.set(value.deviceID, value);
                }
              });
              this.checkSelectAllStatus();
              this.getSelectedDevicesList();
            }
          });
      } else {
        this.isSelectAllClicked = false;
        this.isAllSelectedData.clear();
        this.getSelectedDevicesList();
      }
    } else {
      if (event) {
        this.isSelectAllClicked = true;
        this.isMasterSel = this.isSelectAllClicked;
        if (this.isProfilePage) {
          this.filterString = this.filterString ? (this.filterString + `&package=${this.pfID}`) : `&package=${this.pfID}`
        }
        this.devicesService.selectAllDevices(this.filterString)
          .subscribe(res => {
            // if (!(this.userRole === this.retailHqUser || this.userRole === this.regionalHqUser)){
            // Commenting below So that APP consumes API response(When select all clicked).
            res.device.forEach(value => {
              if (this.isProfilePage || value.isIposLite) { // if non-intel devices included shouldn't be included when user click select all
                if (!this.checkDisable(value)) {
                  this.isAllSelectedData.set(value.deviceID, value);
                }
              } else {
                this.isAllSelectedData.set(value.deviceID, value);
              }
            });
            this.checkSelectAllStatus();
            this.getSelectedDevicesList();
            // }
          });
      } else {
        this.isSelectAllClicked = false;
        this.isAllSelectedData.clear();
        this.getSelectedDevicesList();
      }
    }
  }

  getSelectedDevicesList() {
    this.selectedDeviceList = Array.from(this.isAllSelectedData.values());
    if (this.isProfilePage) {
      this.isDisabled = this.selectedDeviceList.length > 0 ? false : true;
    } else {
      this.isDisabled = this.selectedDeviceList.length > 1 ? false : true;
    }
    this.sideNav = (this.selectedDeviceList.length > 1) ? 'promo' : 'deviceInfo';
    this.selectedDeviceNameList = this.selectedDeviceList.map(e => e.deviceName)
      .join(', ');
    this.sendSelectedItem = this.selectedDeviceList.length > 1;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.isCollapsed = [];
  }

  updateDevice(deleteModal, device: Device) {
    let checkString = GlobalConstants.CHROME;
    if (device.operatingSystem === checkString || device.operatingSystem === checkString.toLowerCase() || device.operatingSystem === checkString.toUpperCase() || device.operatingSystem === GlobalConstants.CHROMEOS) {
      this.isOperatingChorm = true;
    } else {
      this.isOperatingChorm = false;
    }

    this.segmentSuccess = false;
    this.sideNav = 'deviceInfo';
    this.updateDeviceInfo = device;
    this.lastUpdate = this.updateDeviceInfo.deviceUpdatedTime;
    this.isSingleDeviceSelected = true;
    this.selectedDeviceList=[this.updateDeviceInfo]; // IIT2-22401 bug-fix    
    this.openUpdatePopUP(deleteModal);
  }

  updateMultiDevice(deleteModal) {
    let checkString = GlobalConstants.CHROME;
    let result = this.selectedDeviceList.filter(function (index) {
      return !(index.operatingSystem === checkString || index.operatingSystem === checkString.toLowerCase() || index.operatingSystem === checkString.toUpperCase());
    });
    let skuData = [];
    let blankSKU = false;
    for (let i = 0; i < this.selectedDeviceList?.length; i++) {
      if (!this.selectedDeviceList[i].skuID || this.selectedDeviceList[i]?.skuID === '') {
        blankSKU = true;
        break;
      } else if (skuData.indexOf(this.selectedDeviceList[i].skuID) == -1) {
        skuData.push(this.selectedDeviceList[i].skuID);
      }
    }
    if (this.retailerInfo?.enablePriceMultiDevices && (blankSKU || skuData?.length > 1)) {
      this.priceMetaData.blockSKU = true;
    } else {
      this.priceMetaData.blockSKU = false;
    }
    if (result.length > 0) this.isOperatingChorm = false; else this.isOperatingChorm = true;
    this.isSingleDeviceSelected = false;
    this.openUpdatePopUP(deleteModal);
  }

  openUpdatePopUP(deleteModal) {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.windowClass = 'update-device-class';
    this.modalRef = this.modalService.open(deleteModal, this.modalOption);
    this.modalRef.result.then();
  }

  setSideNav(value: string) {
    this.sideNav = value;
    window.scroll(0, 0);
  }

  dismiss() {
    this.modalRef.dismiss();
    // Store clear on popup closed
    this.deviceStore.clearStoreData();
    this.infoSuccess = false;
    this.isUpdatesPushed = false;
    this.infoBannerSuccess = false;
    this.infoPriceSuccess = false;
    this.infoAutoshutdownSuccess = false;
    this.promoSuccess = false;
    this.factTagSuccess = false;
    this.customMainSuccess = false;
    this.idleExperienceSuccess = false;
  }

  updateViaCSV() {
    this.openModal = !this.openModal;
  }

  closeUploadCSV() {
    this.openModal = false;
    this.file = {};
    this.finalName = '';
    this.incorrectError = false;
    this.importdata = {};
    this.showcsvError = false;
    if (this.userRole === this.retailHqUser || this.userRole === this.regionalHqUser) this.getAllDevicesDataForRetailer();
    else this.getAllDevicesByUserId();
  }

  onFilechange(fileInput: any) {
    this.incorrectError = false;
    this.fileName = fileInput.target.files[0].name;
    const fileType = this.fileName.split('.')
      .pop();
    if (this.fileName.length > 30) {
      const flname = this.fileName.substring(0, 30);
      this.finalName = `${flname}...${fileType}`;
    } else {
      this.finalName = this.fileName;
    }
    if ((fileType || '').toLowerCase() !== GlobalConstants.FILE_TYPE_CSV) {
      this.showcsvError = true;

      return;
    } else {
      this.showcsvError = false;
    }
    this.file = fileInput.target.files[0];
    fileInput.target.value = '';
  }

  closeSuccesspopup() {
    this.successPopup = false;
    this.closeUploadCSV();
  }

  uploadFile() {
    const input = new FormData();
    input.append('file', this.file);
    if (this.userRole === this.retailHqUser || this.userRole === this.regionalHqUser) {
      this.devicesService
        .updateViaCSVRetailHQUser(input, this.isDashboardPriceSupress, this.customSrtEnabled)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          data => {
            this.importdata = data;
            if (data.responseContext.success === true) {
              this.incorrectError = false;
              this.openModal = false;
              this.successPopup = true;
              this.finalName = '';
            }
            this.googleAnalyticsService.updateViaCsv();
            // TODO: unsubscribe
          },
          (err) => {
            this.incorrectError = true;
            this.errorMessage = err.missingFields;
          }
        );
    } else
      if (this.userRole === this.storeUser) {
        this.devicesService
          .updateViaCSV(input)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            data => {
              this.importdata = data;
              if (data.responseContext.success === true) {
                this.incorrectError = false;
                this.openModal = false;
                this.successPopup = true;
                this.finalName = '';
              }
              // TODO: unsubscribe
            },
            (err) => {
              this.incorrectError = true;
              this.errorMessage = err.missingFields;
            }
          );
      }

  }

  //GLS fix: Translation applied for Connectivity types
  spell(option: string) {
    if (option === DevicesConstants.INACTIVE) {
      return GlobalConstants.INACTIVE_TEXT;
    } else if (option === DevicesConstants.RECENTLY_CONNECTED) {
      return GlobalConstants.RECENTLY_CONNECTED_TEXT;
    } else if (option === DevicesConstants.DISCONNECTED) {
      this.statusHoverText = this.disconnectedStatusHoverText;
      return GlobalConstants.DISCONNECTED_TEXT;
    } else if (option === DevicesConstants.CONNECTED) {
      this.statusHoverText = this.connectedStatusHoverText;
      return GlobalConstants.CONNECTED_TEXT;
    } else if (option === DevicesConstants.TWO_WEEKS) {
      this.statusHoverText = this.twoPlusweeksDisconnectedStatusHoverText;
      return GlobalConstants.ACTIVE_TEXT;
    } else {
      return;
    }
  }

  createDeviceHeaders(ifTemplate?) {
    const devicerequestBody = {
      csvHeaders: []
    };
    devicerequestBody.csvHeaders.push(GlobalConstants.DEVICE_UUID);
    devicerequestBody.csvHeaders.push(GlobalConstants.SKU_CODE);
    devicerequestBody.csvHeaders.push(GlobalConstants.DEVICE_NAME);
    devicerequestBody.csvHeaders.push(GlobalConstants.BATTERY_LIFE);
    if (!this.isDashboardPriceSupress) {
      devicerequestBody.csvHeaders.push(GlobalConstants.PRIMARY_PRICE);
      devicerequestBody.csvHeaders.push(GlobalConstants.SECONDARY_PRICE);
      devicerequestBody.csvHeaders.push(GlobalConstants.PRICE_STRIKETHROUGH);
      devicerequestBody.csvHeaders.push(GlobalConstants.PRICE_CONTENT_GID);
    }
    devicerequestBody.csvHeaders.push(GlobalConstants.SEGMENT_ID_CSV);
    devicerequestBody.csvHeaders.push(GlobalConstants.PROMOCONTENT_1);
    devicerequestBody.csvHeaders.push(GlobalConstants.PROMOCONTENT_2);
    devicerequestBody.csvHeaders.push(GlobalConstants.PROMOCONTENT_3);
    devicerequestBody.csvHeaders.push(GlobalConstants.BANNERID_1);
    devicerequestBody.csvHeaders.push(GlobalConstants.BANNERID_2);
    devicerequestBody.csvHeaders.push(GlobalConstants.BANNERID_3);
    if (this.customSrtEnabled) {
      devicerequestBody.csvHeaders.push(GlobalConstants.CUSTOM_MAIN_TILE_ID);
    }
    if (!ifTemplate) {
      devicerequestBody.csvHeaders.push(GlobalConstants.PROCESSOR_GENERATION);
      if (this.isProfilePage) {
        devicerequestBody.csvHeaders.push(DevicesConstants.PUSH_STATUS);
        devicerequestBody.csvHeaders.push(DevicesConstants.LAST_CONNECTED);
      }
    }
    devicerequestBody.csvHeaders.push(GlobalConstants.RETAILER_NAME_SEARCH);
    devicerequestBody.csvHeaders.push(GlobalConstants.BRAND_CAPS);
    devicerequestBody.csvHeaders.push(GlobalConstants.IPOS_VERSION);
    devicerequestBody.csvHeaders.push(GlobalConstants.VA_INCLUDED);
    devicerequestBody.csvHeaders.push(GlobalConstants.INSTALLATION_DATETIME);
    devicerequestBody.csvHeaders.push(DevicesConstants.LAST_UPDATE);
    if (!this.isProfilePage) {
      devicerequestBody.csvHeaders.push(DevicesConstants.LAST_CONNECTED);
    }
    devicerequestBody.csvHeaders.push(GlobalConstants.CONNECTIVITY_STATUS);

    return devicerequestBody.csvHeaders;
  }
  ifTimezoneCst() {
    const now = new Date();
    const dateString = now.toString();
    if (dateString.includes('GMT+08')) return true;
    else return false;  
  }
  downloadCsvFile() {
    if (navigator.onLine) {
      const devicerequestBody = {
        csvHeaders: this.createDeviceHeaders()
      };
      if (this.isIposChinaEnabled && this.ifTimezoneCst()) this.timeZoneCST = true;
      if (this.filterString) {
        if (this.isProfilePage) {
          this.filterString = this.filterString ? (this.filterString + `&package=${this.pfID}`) : `&package=${this.pfID}`;
        }
        this.devicesService.postdownloadcsvDevicebyFilter(this.filterString, devicerequestBody, this.retailerID, this.isDashboardPriceSupress, this.customSrtEnabled, this.timeZoneCST)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(getAllDevicesResponseByFilter => {
            var devicesResponseByFilter: any = getAllDevicesResponseByFilter;
            this.downloadCsv(devicesResponseByFilter);
          });
      } else {
        //Retailerid added to service parameters.UAT-568
        this.devicesService.postAllUsersForCsv(devicerequestBody, this.retailerID, this.isDashboardPriceSupress, this.customSrtEnabled, this.pfID, this.timeZoneCST)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(getAllDevicesResponse => {
            var devicesResponse: any = getAllDevicesResponse
            this.downloadCsv(devicesResponse);
          });
      }
    }
  }

  downloadCsv(csvResponse) {
    this.allUserscsvData = csvResponse;
    let todayTime = new Date();
    let month = (todayTime.getMonth() + 1);
    let day = ('0' + todayTime.getDate()).slice(-2);
    let year = todayTime.getFullYear();
    let filename = GlobalConstants.DEVICE_CSV_FILENAME;
    let userfilename = month + '_' + day + '_' + year + '_' + filename;
    const blob = new Blob(['\ufeff' + this.allUserscsvData], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", userfilename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  removeItem(item) {
    this.openDeleteModalPopup = !this.openDeleteModalPopup;
    this.isremoved = true;
    this.isSingleDeviceSelected = true;
    this.removeMessage = DevicesConstants.REMOVE_ONE_DEVICE;
    this.deviceName = item.deviceName;
    this.singleDelete = item.deviceID;
  }

  closeRemoveDeviceModal() {
    if (this.userRole === this.retailHqUser || this.userRole === this.regionalHqUser) this.getAllDevicesDataForRetailer(this.filterString);
    else this.getAllDevicesByUserId(this.filterString);
    this.openDeleteModalPopup = false;
    }

  cancelPopupButton() {
    this.openDeleteModalPopup = false;
    // this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    // this.showTo = Math.min(this.page * this.tableSize, this.allDevicesData.length);
  }

  removeAllSelectedDevice() {
    if (this.selectedDeviceList.length > 0) {
      this.openDeleteModalPopup = !this.openDeleteModalPopup;
      this.isremoved = true;
      if (this.selectedDeviceList.length === 1) {
        this.isSingleDeviceSelected = true;
        this.removeMessage = DevicesConstants.REMOVE_ONE_DEVICE;
        this.deviceName = this.selectedDeviceList[0].deviceName;
      } else {
        this.isSingleDeviceSelected = false;
        this.removeMessage = DevicesConstants.REMOVE_MULTIPLE_DEVICE;
      }
    }
  }

  removeDeviceList() {
    if (this.singleDelete === '') {
      const removingList = this.selectedDeviceList.map(item => item.deviceID);
      //IIT2-4967
      this.removeDevices({ 'deviceIDs': removingList });
    } else {
      this.removeDevices({ 'deviceIDs': [this.singleDelete] });
    }
  }

  removeDevices(removeData) {
    this.devicesService.deleteDevices(removeData, this.retailerID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(deleteDomainResponse => {
        if (deleteDomainResponse.responseContext.statusCode === 200) {
          this.searchData = '';
          this.isMasterSel = false;
          this.isremoved = false;
          this.singleDelete = '';
          this.isDisabled = true;
          this.isAllSelectedData.clear();
        }
      },
        error => {
          this.handleError(error, this.constructor.name);
        });
  }

  // Handling error within the component
  handleError(error, componentName) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}\nComponent: ${componentName}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.responseContext.exceptionResponse.errorCode}\nMessage: ${error.responseContext.exceptionResponse.errorMessage} with Status Code: ${error.responseContext.exceptionResponse.statusCode}\nComponent: ${componentName}`;
    }

    return throwError(errorMessage);
  }
  currentSegmentStatus(value) {
    this.segmentSuccess = value;
  }

  currentInfoStatus(data) {
    this.infoSuccess = data;
  }

  currentPushStatus(data) {
    this.isUpdatesPushed = data;
    this.infoSuccess = false;
    this.segmentSuccess = false;
    this.infoBannerSuccess = false;
    this.infoPriceSuccess = false;
    this.infoAutoshutdownSuccess = false;
    this.promoSuccess = false;
    this.factTagSuccess = false;
    this.customMainSuccess = false;
    this.idleExperienceSuccess = false;
    this.getAllDevicesByUserId(this.filterString);
    this.dismiss();
    this.isMasterSel = false;
    this.isAllSelectedData.clear();
    this.isDisabled = true;
  }


  currentBannerStatus(data) {
    this.infoBannerSuccess = data;
  }
  currentPriceContent(data) {
    this.infoPriceSuccess = data;
  }
  currentPromoStatus(data) {
    this.promoSuccess = data;
  }
  currentCustomStatus(data) {
    this.customMainSuccess = data;
  }

  currentFactStatus(data) {
    this.factTagSuccess = data;
  }
  // IIT2-5800
  currentAutoShutdownStatus(data) {
    this.infoAutoshutdownSuccess = data;
  }

  currentIdleExpStatus(data) {
    this.idleExperienceSuccess = data;
  }

  onFilter(selectedFilterName: string, selectedValue: any) {
    this.closeFilter = true;
    this.isAllSelectedData.clear();
    this.isSelectAllClicked = false;
    switch (selectedFilterName) {
      case DevicesConstants.CONNECTIVITY_STATUS_VALUE_FILTER:
        this.connectivityStatusDropdownSelectedValue = this.spell(selectedValue);
        break;
      case DevicesConstants.SEGMENT_VALUE_FILTER:
        this.segmentDropdownSelectedValue = selectedValue;
        break;
      case DevicesConstants.CONTENT_TYPE_VALUE_FILTER:
        this.contentTypeDropdownSelectedValue = selectedValue;
        break;
      case DevicesConstants.SKU_ID_TYPE_FILTER:
        this.skuIdDropdownSelectedvalue = selectedValue;
        break;
      case DevicesConstants.BRAND_VALUE_FILTER:
        this.brandDropdownSelectedValue = selectedValue;
        break;
      case DevicesConstants.DEVICE_TYPE_VALUE_FILTER:
        this.deviceTypeDropdownSelectedValue = selectedValue;
        break;
      case DevicesConstants.PROCESSORS_VALUE_FILTER:
        this.processorsDropdownSelectedValue = selectedValue;
        break;
      case DevicesConstants.OPERATING_SYSTEM_VALUE_FILTER:
        this.operatingSystemDropdownSelectedValue = selectedValue;
        break;
      case DevicesConstants.GAMING_NONGAMING_DEVICE_VALUE_FILTER:
        this.gamingNonGamingDeviceDropdownSelectedValue = selectedValue;
        break;
      case DevicesConstants.PUSH_STATUS_VALUE_FILTER:
        this.pushStatusDropdownSelectedValue = selectedValue;
        break;
      case DevicesConstants.VERSION_NUMBER_VALUE_FILTER:
        this.versionNumberDropdownSelectedValue = selectedValue;
        break;
      case DevicesConstants.IS_DEVICE_EVO_VALUE_FILTER:
        this.deviceEvoDropdownSelectedValue = selectedValue;
        break;
      default:
        return;
    }
    // To revert the new values added for Processor and Device_type values start
    if (selectedFilterName === DevicesConstants.PROCESSORS_VALUE_FILTER) {
      this.processorNames['processors'].forEach(ele => {
        if (selectedValue === ele.name) {
          selectedValue = ele.value
        }
      })
    } else if (selectedFilterName === DevicesConstants.DEVICE_TYPE_VALUE_FILTER) {
      if (selectedValue === GlobalConstants.DEVICE_2_IN_1_OTHERS_NEW) {
        selectedValue = GlobalConstants.DEVICE_2_IN_1_OTHERS;
      } else if (selectedValue === GlobalConstants.DEVICE_2_IN_1_DETACHABLE_NEW) {
        selectedValue = GlobalConstants.DEVICE_2_IN_1_DETACHABLE;
      } else if (selectedValue === GlobalConstants.DEVICE_2_IN_1_CONVERTIBLE_NEW) {
        selectedValue = GlobalConstants.DEVICE_2_IN_1_CONVERTIBLE;
      }
    } // IGC-91 Filter Gaming and Non Gaming Battle stations 
    else if (selectedFilterName === DevicesConstants.GAMING_NONGAMING_DEVICE_VALUE_FILTER) {
      if (selectedValue === DevicesConstants.BATTLE_GAME_STATION) {
        selectedValue = true;
      } else if (selectedValue === DevicesConstants.NON_BATTLE_GAME_STATION) {
        selectedValue = false;
      }
      // IIT2-13197 starts
    } else if (selectedFilterName === DevicesConstants.IS_DEVICE_EVO_VALUE_FILTER) {
      if (selectedValue === this.globConst.YESS) {
        selectedValue = true;
      } else if (selectedValue === this.globConst.NOT) {
        selectedValue = false;
      }
      // IIT2-13197 ends
    }
    // To revert the new values added for Processor and Device_type end
    // Added encodeURIComponent to status filter do avoid issues when special chars included
    const selVal = (selectedValue === this.deviceConst.NO_SKU_ID) ? '' : selectedValue;
    this.selectFilterQueue[selectedFilterName] = encodeURIComponent(selVal);
    this.getFilterSearchData();
    this.searchClose = false;
    this.searchData = DevicesConstants.EMPTY_VALUE;
    this.page = 1;
    this.isDisabled = true;
    this.isMasterSel = false;
  }

  getFilterData() {
    this.filterString = '';
    for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
      if (this.filterString === '') {
        this.filterString = '?' + filterKeyName + '=' + fliterData;
      } else {
        this.filterString += '&' + filterKeyName + '=' + fliterData;
      }
    }
    this.devicesService.getDevicesByFilter(this.filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getFilterDevicesResponse => {
        this.displayDevices = getFilterDevicesResponse.device as Device[];
        this.displayDevices = [...new Set(this.displayDevices)];
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        if (this.displayDevices.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
        } else {
          this.allConnectivityStatusData = [...new Set(getFilterDevicesResponse.device.map(ele => ele.connectivityStatus))].sort();
          this.allSegmentData = [...new Set(getFilterDevicesResponse.device.map(ele => ele.segmentHeadline))].sort();
          this.allContentTypeData = [...new Set(getFilterDevicesResponse.device.map(ele => ele.contentType))].sort();
          this.allBrandData = [...new Set(getFilterDevicesResponse.device.map(ele => ele.brand))].sort();
          this.allDeviceTypeData = [...new Set(getFilterDevicesResponse.device.map(ele => ele.deviceType))].sort();
          this.allProcessorsData = [...new Set(getFilterDevicesResponse.device.map(ele => ele.processor))].sort();
          this.allOperatingSystemData = [...new Set(getFilterDevicesResponse.device.map(ele => ele.operatingSystem))].sort();
          this.allPushStatusData = [...new Set(getFilterDevicesResponse.device.map(ele => ele?.profilePushStatus))].sort();
          this.allVersionNumbersData = [...new Set(getFilterDevicesResponse.device.map(ele => ele?.iposLegalVersion))].sort();
        }
      });
  }

  // tslint:disable-next-line: cyclomatic-complexity
  clearFilter(filterName?: string) {
    this.page = 1;
    this.isDisabled = true;
    this.isMasterSel = false;
    this.isAllSelectedData.clear();
    this.isSelectAllClicked = false;
    this.pushEmptySkuId = false;
    if (filterName && filterName === DevicesConstants.CONNECTIVITY_STATUS_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allConnectivityStatusData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.connectivityStatusDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === DevicesConstants.SEGMENT_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allSegmentData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.segmentDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === DevicesConstants.CONTENT_TYPE_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allContentTypeData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.contentTypeDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === DevicesConstants.SKU_ID_TYPE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allSkuData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.skuIdDropdownSelectedvalue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === DevicesConstants.BRAND_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allBrandData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.brandDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === DevicesConstants.DEVICE_TYPE_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allDeviceTypeData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.deviceTypeDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === DevicesConstants.PROCESSORS_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allProcessorsData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.processorsDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === DevicesConstants.OPERATING_SYSTEM_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allOperatingSystemData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.operatingSystemDropdownSelectedValue = '';
      this.getFilterSearchData();
    } else if (filterName && filterName === DevicesConstants.GAMING_NONGAMING_DEVICE_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allGamingNonGamingdeviceData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.gamingNonGamingDeviceDropdownSelectedValue = null;
      this.getFilterSearchData();
    } else if (filterName === DevicesConstants.PUSH_STATUS_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allPushStatusData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.pushStatusDropdownSelectedValue = '';
      this.getFilterSearchData();

    } else if (filterName === DevicesConstants.VERSION_NUMBER_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      this.allVersionNumbersData = [];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.versionNumberDropdownSelectedValue = '';
      this.getFilterSearchData();
      // For IIT2-13197 starts
    } else if (filterName === DevicesConstants.IS_DEVICE_EVO_VALUE_FILTER) {
      delete this.selectFilterQueue[filterName];
      if (JSON.stringify(this.selectFilterQueue) === JSON.stringify({})) {
        this.searchQueue = {};
        this.filterString = '';
        this.closeFilter = false;
      }
      this.deviceEvoDropdownSelectedValue = null;
      this.getFilterSearchData();
    }
    // IIT2-13197 ends
    else {
      this.filterString = '';
      this.selectFilterQueue = {};
      this.searchQueue = {};
      this.getFilterSearchData();
      this.closeFilter = false;
      this.searchClose = false;
      this.searchData = DevicesConstants.EMPTY_VALUE;
      this.allConnectivityStatusData = [];
      this.allSegmentData = [];
      this.allContentTypeData = [];
      this.allSkuData = [];
      this.allBrandData = [];
      this.allDeviceTypeData = [];
      this.allProcessorsData = [];
      this.allOperatingSystemData = [];
      this.allGamingNonGamingdeviceData = [];
      this.allPushStatusData = [];
      this.allVersionNumbersData = [];
      this.connectivityStatusDropdownSelectedValue = '';
      this.segmentDropdownSelectedValue = '';
      this.contentTypeDropdownSelectedValue = '';
      this.skuIdDropdownSelectedvalue = '';
      this.brandDropdownSelectedValue = '';
      this.deviceTypeDropdownSelectedValue = '';
      this.processorsDropdownSelectedValue = '';
      this.operatingSystemDropdownSelectedValue = '';
      this.gamingNonGamingDeviceDropdownSelectedValue = '';
      this.pushStatusDropdownSelectedValue = '';
      this.versionNumberDropdownSelectedValue = '';
      this.deviceEvoDropdownSelectedValue = '';
    }
  }

  showHideFiltersClick() {
    this.showHideFilters = !this.showHideFilters;
  }

  openModals(modal: any) {
    const gaMetrics = {
      device_info_push_updates: this.infoSuccess,
      promotional_content_push_updates: this.promoSuccess,
      segment_push_updates: this.segmentSuccess,
      banner_carousel_push_updates: this.infoBannerSuccess,
      price_content_push_updates: this.infoPriceSuccess,
      fact_tags_push_updates: this.factTagSuccess,
      push_update_idle_experience: this.idleExperienceSuccess,
      custom_main_tile_content_push_updates: this.customMainSuccess,
      auto_shutdown_push_updates: this.infoAutoshutdownSuccess
    }
    modal.open(this.selectedDeviceList, gaMetrics);
  }

  pushUpdates() {
    this.openModals(this.updatePopup);
  }

  searchDevice(searchData) {
    this.isAllSelectedData.clear();
    this.isSelectAllClicked = false;
    this.searchClose = true;
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.searchTag = DevicesConstants.DEVICE_NAME_SEARCH;
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (searchData && this.searchTag) {
      this.searchQueue = {}; // To clear previous selection.
      this.searchQueue[this.searchTag] = searchData;
      this.getFilterSearchData();
    } else {
      if (this.userRole === this.retailHqUser || this.userRole === this.regionalHqUser || this.userRole === this.deviceExecutive) this.getAllDevicesDataForRetailer();
      else this.getAllDevicesByUserId();
      this.page = 1;
    }
    this.isMasterSel = false;
    this.isDisabled = true;
  }

  searchtheDevicessonEnter(searchData) {
    this.animateThis.nativeElement.blur();
    this.searchDevice(searchData);
  }

  getFilterSearchData() {
    this.filterString = '';
    this.blockCall = false;
    this.isCollapsed = this.isCollapsed?.map(i => i = false);
    this.page = 1;
    if (this.selectFilterQueue || this.searchQueue || this.sortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.selectFilterQueue)) {
        this.filterString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      // block API calls if searchdata includes string % 
      if (this.searchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
          if (String(fliterData).includes("%")) {
            this.blockCall = true;
            break;
          }
        }
      }


      if (!this.blockCall) {
        if ((this.userRole === this.retailHqUser || this.userRole === this.regionalHqUser || this.userRole === this.deviceExecutive) && this.filterString !== '') this.getAllDevicesDataForRetailer(this.filterString);
        else this.getAllDevicesByUserId(this.filterString);
      }
    } else {
      this.getAllDevicesByUserId();
    }
  }

  downloadTemplate() {
    const headers = this.createDeviceHeaders('template');
    let tempHeaders = headers.join(',');
    let todayTime = new Date();
    let month = (todayTime.getMonth() + 1);
    let day = ('0' + todayTime.getDate()).slice(-2);
    let year = todayTime.getFullYear();
    let filename = GlobalConstants.DEVICE_CSV_FILENAME;
    let userfilename = month + '_' + day + '_' + year + '_' + filename;
    const blob = new Blob(['\ufeff' + tempHeaders], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", userfilename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);

  }
  //To return status in required order
  statusList() {
    return [DevicesConstants.CONNECTED, DevicesConstants.DISCONNECTED, DevicesConstants.TWO_WEEKS];
  }
  toggle(index) {
    this.isCollapsed[index] = !this.isCollapsed[index];
  }
  setConnectivityIcon(status: string): string {
    return status === DevicesConstants.CONNECTED ? GlobalConstants.GREEN
      : status === DevicesConstants.DISCONNECTED ? GlobalConstants.YELLOW
        : status === DevicesConstants.TWO_WEEKS ? GlobalConstants.RED
          : '';
  }

  getColor(priceInfo: string, priceType: string): string {
    if (priceInfo) {
      return priceType === GlobalConstants.PRIMARY_TEXT ? JSON.parse(priceInfo)?.price_colors?.fonts?.primary || GlobalConstants.WHITE_COLOR
        : priceType === GlobalConstants.SECONDARY_TEXT ? JSON.parse(priceInfo)?.price_colors?.fonts?.secondary || GlobalConstants.WHITE_COLOR
          : priceType === GlobalConstants.PRICE_BACKGROUND ? JSON.parse(priceInfo)?.price_colors?.backgrounds?.price_label || GlobalConstants.STORELOGO_BGCOLOR
            : GlobalConstants.WHITE_COLOR;
    }
  }
  getStrikeText(pricetext: string): string {
    return `(${pricetext})`;
  }
  getAutoShutDown(item): string {
    let autoShutDown;
    if (item?.autoShutDown) {
      autoShutDown = JSON.parse(item?.autoShutDown);
    }
    if (autoShutDown) {
      let hours = autoShutDown?.autoShutDownHour;
      let minutes = autoShutDown?.autoShutDownMin;
      let enabled = autoShutDown?.autoShutDownTimeEnabled || false;
      if (hours < 10 && hours?.toString()?.length < 2) {
        hours = '0' + hours
      }
      if (minutes < 10 && minutes?.toString()?.length < 2) {
        minutes = '0' + minutes
      }
      return enabled && hours && minutes
        ? `${hours}:${minutes} ${GlobalConstants.HOURS}`
        : GlobalConstants.OFF;
    }
    return GlobalConstants.OFF;
  }
  getProcessorText(deviceData: any) {
    return (deviceData?.deviceConfigurations) ? JSON.parse(deviceData.deviceConfigurations)?.cpu?.display?.en_US : ''
  }
  //IIT2-10050
  showTimePopup() {
    if (!this.isDisabled) {
      this.editPublishDateInfo = Utils.changeSaveDateFormat(Utils.getCurrentDate());
      this.timePopup = true;
    }
  }
  checkIfTimeset(data, check) {
    if (check === 'publish') {
      if (data[0] && data[1]) {
        this.isCustomPublishDateCorrect = false;
      }
    }
    this.checkDisableStatus();
  }
  getLogoContentPublishDate(data) {
    this.customPublishDateResult = this.generateDateTimeZone(data);
    this.checkDisableStatus();
  }
  checkTimeZone(data, check) {
    if (check === GlobalConstants.PUBLISH) this.isCustomPublishTimeZoneSelected = !data
    this.checkDisableStatus();
  }
  generateDateTimeZone(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }
  //To just close the popup
  closeTimePopup(n) {
    this.resetTimeZonePopopupVal();
    this.checkDisabled = false;
    this.tempFullData = {};
    if (n === 1) {
      this.timePopup = false;
    } else if (n === 2) {
      this.bandwidthPopup = false;
    } else if (n === 3) {
      this.showLicensePopUp = false;
    }
  }

  //To close the popup and shows the previous popup
  hideTimePopup(n) {
    if (n === 1) {
      this.timePopup = false;
    } else if (n === 2) {
      this.isCustomPublishDateCorrect = undefined;
      this.isCustomPublishTimeZoneSelected = false;
      this.bandwidthPopup = false;
      this.datetimePickerFrm = this.formBuilder.group({
        time: { hour: this.tempFullData.time?.hour, minute: this.tempFullData.time?.minute },
        time2: { hour: this.tempFullData.time2?.hour, minute: this.tempFullData.time2?.minute }
      });
      this.customPublishDateResult = this.tempFullData.customPublishDateResult;
      this.blockoutExpanded = this.tempFullData.blockoutExpanded;
      this.editPublishDateInfo = this.customPublishDateResult;
      this.timePopup = true;
      this.checkDisableStatus();
    } else if (n === 3) {
      this.bandwidthPopup = true;
      this.showLicensePopUp = false;
    } else if (n === 4) {
      this.isAlldevicesSelected = false;
      this.showLicensePopUp = false;
      this.updatesPushed = false;
      this.getSelectedDevicesList();
      this.displayDevices = [];
      this.clearFilter();
      this.resetTimeZonePopopupVal();
    }
  }
  customValidation() {
    this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
  }
  continueTobandwidthPopup() {
    this.customValidation();
    if (!this.isCustomPublishDateCorrect && !this.isCustomPublishTimeZoneSelected && this.customPublishDateResult) {
      this.tempFullData = {
        time: this.datetimePickerFrm?.controls?.time?.value,
        time2: this.datetimePickerFrm?.controls?.time2?.value,
        customPublishDateResult: this.customPublishDateResult,
        blockoutExpanded: this.blockoutExpanded
      };
      this.hideTimePopup(1);
      this.bandwidthPopup = true;
    }
  }
  bandwidth() {
    if (this.isProfilePage) {
      if (this.pkgdata && this.pkgdata?.packageSize !== '') {
        return this.cmnService.formatSize(this.pkgdata?.packageSize);
      } else {
        return '0 bytes';
      }
    }
  }
  showLicenseModal() {
    this.bandwidthPopup = false;
    this.showLicensePopUp = true;
  }

  //Method to send data to backend API call
  PushProfiles() {
    let payLoadData = {
      pushProfiles: [{
        profileID: this.pkgdata.profileId,
        upgradeDateTime: Utils.changeSaveDateFormat(this.customPublishDateResult.toString()),
        blackoutStartTime: this.formatTime(this.datetimePickerFrm.controls?.time?.value),
        blackoutEndTime: this.formatTime(this.datetimePickerFrm.controls?.time2?.value)
      }],
      deviceIDs: [...this.isAllSelectedData.keys()],

    }
    this.devicesService.pushProfiles(this.retailerID, payLoadData,
      (this.userRole === this.storeUser ? sessionStorage.getItem(GlobalConstants.STORE_ID_KEY) : ''))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(resp => {
        this.updatesPushed = true;
        const isBlackout = payLoadData.pushProfiles[0].blackoutStartTime && payLoadData.pushProfiles[0].blackoutEndTime ? true : false;
        this.googleAnalyticsService.otaDevice(this.selectedDeviceList.length, this.pkgdata.profileId, this.pkgdata.profileName, isBlackout);
      },
        error => { });
  }
  checkDisable(item?) {
    if (item?.isIposLite && !this.isProfilePage) {
      return true;
    }
    if (this.isProfilePage) {
      if (item) { //for individual textbox
        let statusCheck = (this.pkgdata && this.pkgdata?.packageStatus == 'completed') ? false : true;
        if (!statusCheck) {
          if (this.pkgdata?.allowNonIntel === false) { // If pkg status completed,non-intel false
            let deviceConfig = JSON.parse(item?.deviceConfigurations);
            return (deviceConfig?.cpu.manufacturer !== GlobalConstants.INTEL || (deviceConfig?.cpu.confidence === 0)) ? true : false;
          } else {
            return statusCheck;
          }
        } else {
          return statusCheck;
        }
      } else { // For select all
        return (this.pkgdata && this.pkgdata?.packageStatus == 'completed') ? false : true;
      }
    } else {
      return false;
    }
  }
  //IIT2-10875
  explandBlockout() {
    this.blockoutExpanded = !this.blockoutExpanded;
  }
  createDateTimePickerFrm() {
    this.datetimePickerFrm = this.formBuilder.group({
      time: { hour: null, minute: null },
      time2: { hour: null, minute: null }
    });
  }
  setSelectTime(time) {
    this.datetimePickerFrm.controls.time.setValue({
      hour: time.hour,
      minute: time.minute
    }, { onlySelf: true, emitEvent: false });
    this.datetimePickerFrm.controls.time2.setValue({
      hour: time.hour,
      minute: time.minute
    }, { onlySelf: true, emitEvent: false });
  }

  //method to show error text
  compareTimes() {
    if (this.datetimePickerFrm?.controls.time?.value?.hour !== null && this.datetimePickerFrm?.controls.time2?.value?.hour !== null && this.datetimePickerFrm?.controls?.time?.value?.minute !== null && this.datetimePickerFrm?.controls?.time2?.value?.minute !== null) {
      return this.compareTimeHourMinutes();
    } else {
      return false;
    }
  }

  //Method to check if both start and end times selected same values
  compareTimeHourMinutes() {
    if ((this.datetimePickerFrm?.controls?.time?.value?.hour === this.datetimePickerFrm?.controls?.time2?.value?.hour) && (this.datetimePickerFrm?.controls?.time?.value?.minute === this.datetimePickerFrm?.controls?.time2?.value?.minute)) {
      return true;
    } else {
      return false;
    }
  }
  //Method to check whether to enable continue button or not 
  checkDisableStatus() {
    if (!this.isCustomPublishDateCorrect && !this.isCustomPublishTimeZoneSelected && this.customPublishDateResult) {
      if (!this.datetimePickerFrm?.controls.time?.value || !this.datetimePickerFrm?.controls.time2?.value) {
        this.checkDisabled = true;
      } else {
        if (this.datetimePickerFrm?.controls.time?.value?.hour == null && this.datetimePickerFrm?.controls.time2?.value?.hour == null && this.datetimePickerFrm?.controls?.time?.value?.minute == null && this.datetimePickerFrm?.controls?.time2?.value?.minute == null) {
          this.checkDisabled = false;
        } else {
          if (this.datetimePickerFrm?.controls.time?.value?.hour !== null && this.datetimePickerFrm?.controls.time2?.value?.hour !== null && this.datetimePickerFrm?.controls?.time?.value?.minute !== null && this.datetimePickerFrm?.controls?.time2?.value?.minute !== null) {
            this.checkDisabled = this.compareTimeHourMinutes();
          } else {
            this.checkDisabled = true;
          }
        }
      }
    } else {
      this.checkDisabled = true;
    }
  }
  //Method to format blackoutStart and end time
  formatTime(time) {
    const appendZeroForSingleDigit = (i: number): string => i < 10 ? `0${i}` : `${i}`;
    if (time?.hour == undefined || time?.minute == undefined) {
      return null;
    } else {
      return appendZeroForSingleDigit(time?.hour?.toString()) + ':' + appendZeroForSingleDigit(time?.minute?.toString());
    }
  }
  //method to reset TimeZone PopopupVal
  resetTimeZonePopopupVal() {
    this.isCustomPublishDateCorrect = undefined;
    this.isCustomPublishTimeZoneSelected = false;
    this.customPublishDateResult = undefined;
    this.createDateTimePickerFrm();
    this.blockoutExpanded = false;
  }
  compareVersionCheck(versionNo, isIposLite?) {
    if (versionNo) {
      let compareWithVersion = isIposLite ? this.compareLiteVersion.replace(/cy/i, "").replaceAll(".", "") : this.compareVersion.replace(/cy/i, "").replaceAll(".", "");
      let currentVersion = versionNo.replace(/cy/i, "").replaceAll(".", "");
      let res = (currentVersion - compareWithVersion >= 0) ? true : false;
      return res;
    }
  }

  checkSelectAllStatus() {
    this.displayDevices.forEach(ele => {
      ele.isSelected = this.isAllSelectedData.has(ele?.deviceID);
    });

    const isAllChecked = this.displayDevices.every(item => {
      if (item?.isSelected) {
        return true;
      } else {
        if (this.pkgdata?.allowNonIntel === false) {
          return (JSON.parse(item.deviceConfigurations)?.cpu.manufacturer !== GlobalConstants.INTEL || (JSON.parse(item.deviceConfigurations)?.cpu.confidence === 0));
        }
        else {
          if (item?.isIposLite) {
            return true;
          }
          return false;
        }
      }
    });

    this.isMasterSel = isAllChecked;
    this.isAlldevicesSelected = this.isMasterSel;
  }

  statusOnHover(option: string) {
    if (option === DevicesConstants.DISCONNECTED) {
      return this.statusHoverText = this.disconnectedStatusHoverText;
    } else if (option === DevicesConstants.CONNECTED) {
      return this.statusHoverText = this.connectedStatusHoverText;
    } else if (option === DevicesConstants.TWO_WEEKS) {
      return this.statusHoverText = this.twoPlusweeksDisconnectedStatusHoverText;
    }
  }

}
